module.exports = __webpack_public_path__ + "img/magento-banner_medium@2x.6dfd635e.jpg";